import {
    createSlice,
    PayloadAction,
    createAsyncThunk
} from "@reduxjs/toolkit";
import {
    RootState
} from "../store";
import apiClient from "../api/client";

export const requestVM = createAsyncThunk('vmsettings/requestvm', async (reqData: string, {
    rejectWithValue
}) => {
    try {
        const response = await apiClient.post('vmsettings/requestvm', reqData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("access_token")
            }
        });
        return response.data

    } catch (err) {
        console.error(err);
        let error = err;
        return rejectWithValue(error)
    }
});

export const vmStatus = createAsyncThunk('vmsettings/vmstatus', async (_, {rejectWithValue}) => {
    try {
        const response = await apiClient.get('vmsettings/vmstatus', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("access_token")
            }
        });
        return response.data

    } catch (err) {
        console.error(err);
        let error = err;
        return rejectWithValue(error)
    }
});

export const guacamoleCreds = createAsyncThunk('userauth/guacamoleCreds', async (_, {rejectWithValue}) => {
    try {
        const response = await apiClient.get('userauth/guacamoleCreds', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("access_token")
            }
        });
        return response.data

    } catch (err) {
        console.error(err);
        let error = err;
        return rejectWithValue(error)
    }
});

export const snapshots = createAsyncThunk('vmsettings/snapshots', async (_, {rejectWithValue}) => {
    try {
        const response = await apiClient.get('vmsettings/snapshots', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("access_token")
            }
        });
        return response.data

    } catch (err) {
        console.error(err);
        let error = err;
        return rejectWithValue(error)
    }
});

export const takeSnapshot = createAsyncThunk('vmsettings/snapshotvm', async (reqData: string, {
	rejectWithValue
}) => {
	try {
        const response = await apiClient.post('vmsettings/snapshotvm', reqData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("access_token")
            }
        });
        return response.data
	} catch (err) {
        console.error(err);
        let error = err;
        return rejectWithValue(error)
	}
});

export const turnOnVM = createAsyncThunk('vmsettings/turnon', async (reqData: string, {
    rejectWithValue
}) => {
    try {
        const response = await apiClient.post('vmsettings/turnon', reqData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("access_token")
            }
        });
        return response.data

    } catch (err) {
        console.error(err);
        let error = err;
        return rejectWithValue(error)
    }
});

export const turnOffVM = createAsyncThunk('vmsettings/turnoff', async (reqData: string, {
    rejectWithValue
}) => {
    try {
        const response = await apiClient.post('vmsettings/turnon', reqData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("access_token")
            }
        });
        return response.data
    } catch (err) {
        console.error(err);
        let error = err;
        return rejectWithValue(error)
    }
});


export const revertVM = createAsyncThunk('vmsettings/revertvm', async (reqData: string, {
    rejectWithValue
}) => {
    try {
        const response = await apiClient.post('vmsettings/revertvm', reqData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("access_token")
            }
        });
        return response.data
    } catch (err) {
        console.error(err);
        let error = err;
        return rejectWithValue(error)
    }
});


interface VmState {
    turnedOn: boolean,
    reverted: boolean,
    vmID: string,
    vmOS: string,
    isInfected: boolean,
    snapshots: string[],
	desiredRevertSnapshot: string,
	snapshotLoading: boolean,
	snapshotError: string,
	snapshotData: string,
    status: string,
    aquired: boolean,
    guac_username: string,
    guac_password: string,
}

// Below we set up our initial state. Feel free to add more if you'd like more information about users to be shown, for instance a biography.
const initialState: VmState = {
    turnedOn: false,
    reverted: false,
    vmID: '',
    vmOS: '',
    isInfected: false,
	snapshots: [],
	desiredRevertSnapshot: "",
    status: "",
	snapshotLoading: false,
	snapshotError: "",
	snapshotData: "",
    aquired: false,
    guac_username: "",
    guac_password: "",
}

export const vmSlice = createSlice({
    name: 'vm',
    initialState,
    reducers: {
        turnOn: (state: VmState) => {
            state.turnedOn = true
        },
        revert: (state: VmState) => {
            state.reverted = true;
        },
        changeVMID: (state: VmState, action: PayloadAction < string > ) => {
            state.vmID = action.payload;
        },
        changeVMOS: (state: VmState, action: PayloadAction < string > ) => {
            state.vmOS = action.payload;
        },
        infectVM: (state: VmState) => {
            state.isInfected = true;
        },
		setDesiredRevertSnapshot: (state: VmState, action: PayloadAction < string > ) => {
			state.desiredRevertSnapshot = action.payload;
		}
    },
    extraReducers: (builder) => {
        builder.addCase(requestVM.pending, (state: VmState) => {
            state.status = 'Getting Virtual Machine';
        })
        builder.addCase(requestVM.fulfilled, (state: VmState, action: PayloadAction < any > ) => {
            state.status = 'Virtual Machine Aquired';
            state.aquired = true;
            state.turnedOn = true;
            state.guac_username = action.payload.guac_username;
            state.guac_password = action.payload.guac_password;
            let guacdict = JSON.parse(action.payload.guac_token_stuff);
            try {
                let GUAC_AUTH = {
                    authToken: guacdict.authToken,
                    availableDataSources: [guacdict.availableDataSources[0]],
                    dataSource: guacdict.dataSource,
                    username: guacdict.username
                }
                document.cookie = "GUAC_AUTH = " + JSON.stringify(GUAC_AUTH) + "; SameSite=None; Secure";
            } catch (error) {
                console.error("Error getting GUAC_AUTH")
                console.error(error)
            }
        })
        builder.addCase(requestVM.rejected, (state: VmState) => {
            state.status = 'Error getting virtual machine. Maybe you already claimed one?';
        })
        builder.addCase(vmStatus.pending, (state: VmState) => {
            state.status = 'Getting Virtual Machine Status';
        })
        builder.addCase(vmStatus.fulfilled, (state: VmState, action: PayloadAction < any > ) => {
            state.status = 'Refresh Successful';
            state.aquired = true;
            state.turnedOn = action.payload.status === "Running";
        })
        builder.addCase(vmStatus.rejected, (state: VmState) => {
            state.status = 'Make sure to claim a VM first.';
        })
		builder.addCase(guacamoleCreds.pending, (state: VmState) => {
		})
        builder.addCase(guacamoleCreds.fulfilled, (state: VmState, action: PayloadAction < any > ) => {
            state.guac_username = action.payload.guac_username;
            state.guac_password = action.payload.guac_password;
            let guacdict = JSON.parse(action.payload.guac_token_stuff);
            try {
                let GUAC_AUTH = {
                    authToken: guacdict.authToken,
                    availableDataSources: [guacdict.availableDataSources[0]],
                    dataSource: guacdict.dataSource,
                    username: guacdict.username
                }
                document.cookie = "GUAC_AUTH = " + JSON.stringify(GUAC_AUTH) + "; SameSite=None; Secure";
            } catch (error) {
                console.error("Error getting GUAC_AUTH")
                console.error(error)
            }
        })
        builder.addCase(guacamoleCreds.rejected, (state: VmState) => {
            state.status = 'Make sure to claim a VM first.';
        })
        builder.addCase(snapshots.pending, (_) => {
        })
        builder.addCase(snapshots.fulfilled, (state: VmState, action: PayloadAction < any > ) => {
            state.snapshots = action.payload.snapshots;
        })
        builder.addCase(snapshots.rejected, (state: VmState) => {
        })
        builder.addCase(takeSnapshot.pending, (state: VmState) => {
			state.snapshotLoading = true;
			state.snapshotError = "";
        })
        builder.addCase(takeSnapshot.fulfilled, (state: VmState, action: PayloadAction < any > ) => {
			state.snapshotLoading = false;
			state.snapshotData = action.payload.message;
        })
        builder.addCase(takeSnapshot.rejected, (state: VmState, action: PayloadAction < any > ) => {
			state.snapshotLoading = false;
			state.snapshotError = action.payload.response.data.message;
        })
        builder.addCase(turnOnVM.pending, (state: VmState) => {
            state.status = 'Starting Virtual Machine';
        })
        builder.addCase(turnOnVM.fulfilled, (state: VmState) => {
            state.status = 'Virtual Machine Running';
            state.turnedOn = true;
        })
        builder.addCase(turnOnVM.rejected, (state: VmState) => {
            state.status = 'Error starting Virtual Machine';
        })
        builder.addCase(turnOffVM.pending, (state: VmState) => {
            state.status = 'Shutting Down Virtual Machine';
        })
        builder.addCase(turnOffVM.fulfilled, (state: VmState) => {
            state.status = 'Virtual Machine Shutting Down';
            state.turnedOn = false;
        })
        builder.addCase(turnOffVM.rejected, (state: VmState) => {
            state.status = 'Error Shutting Down Virtual Machine';
        })
    }
})

export const {
    turnOn,
    revert,
    changeVMID,
    changeVMOS,
    infectVM,
	setDesiredRevertSnapshot
} = vmSlice.actions

export const selectVM = (state: RootState) => state.virtualMachine;

export default vmSlice.reducer
